export default "__VITE_ASSET__Chaw8kdd__"